const errorCodes: Record<string, string> = {
  '1000': 'Error desconocido',
  '1001': 'Datos recibidos en alguna petición inválidos',
  '1101': 'Usuario bloqueado',
  '1102':
    'El nombre de usuario introducido ya se encuentra en nuestra base de datos',
  '1103':
    'El correo electrónico introducido ya se encuentra en nuestra base de datos',
  '1104': 'No se ha recibido la cabecera api-key',
  '1107':
    'El usuario ha gastado el límite de firmas y/o fecha y no puede firmar',
  '1108': 'El usuario no tiene permisos para realizar esta acción',
  '1307': 'El objeto recibido no puede convertirse en un JSON',
  '1308':
    'Error al crear el documento, posiblemente por una estructura de datos incorrecta',
  '1309':
    'El hash sha1 calculado del documento en base64 recibido, no coincide con el hash calculado en nuestros sistemas',
  '1310': 'Se ha recibido una operación duplicada a través del API cliente',
  '1301': 'No se ha recibido la cabecera Content-Type: text/plain',
  '1302': 'No se ha recibido la cabecera date con el timestamp en milisegundos',
  '1303': 'No se ha recibido la cabecera hmac',
  '1304': 'No se ha recibido la cabecera api-key',
  '1305': 'La petición ha caducado',
  '1306': 'La cabecera HMAC no coincide con la calculada',
  '1504': 'El certificado seleccionado no pertenece al usuario que va a firmar',
  '1505':
    'Se está intentando firmar un documento con un certificado sin haber seleccionado un usuario de la plataforma',
  '1507':
    'No se ha enviado el parámetro certificatePassword necesario para firmar con un certificado que requiere contraseña',
  '1508': 'La contraseña del certificado es incorrecta',
  '1509': 'Se han recibido mas ficheros de los que soporta el plan contratado',
  '1510':
    'Se ha recibido un fichero con un tamaño mayor al soportado por el plan contratado',
  '1511': 'Se ha recibido un documento inválido',
  '1512': 'No se ha recibido ningún documento para firmar',
  '1513': 'No se ha enviado ninguna extensión en el nombre del fichero',
  '1514': 'Se ha recibido un fichero con una extensión no soportada',
  '1515':
    'El MIME type no se corresponde con la extensión del fichero recibido',
  '1516': 'El nombre del fichero recibido no es válido',
  '1517': 'La firma grafométrica solo permite ficheros conextensión PDF'
}

export default errorCodes
